var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBackword = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m3.6 12 8.202-8.202L13.004 5l-7 7 7 7-1.202 1.202z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m11.6 12 8.202-8.202L21.004 5l-7 7 7 7-1.202 1.202z"
})));
export { SvgBackword as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMuNTk5NjEgMTEuOTk5OUwxMS44MDE3IDMuNzk3ODVMMTMuMDAzOCA0Ljk5OTkzTDYuMDAzNzcgMTEuOTk5OUwxMy4wMDM4IDE4Ljk5OTlMMTEuODAxNyAyMC4yMDJMMy41OTk2MSAxMS45OTk5WiIgZmlsbD0iY3VycmVudENvbG9yIi8+CjxwYXRoIGQ9Ik0xMS41OTk2IDExLjk5OTlMMTkuODAxNyAzLjc5Nzg1TDIxLjAwMzggNC45OTk5M0wxNC4wMDM4IDExLjk5OTlMMjEuMDAzOCAxOC45OTk5TDE5LjgwMTcgMjAuMjAyTDExLjU5OTYgMTEuOTk5OVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";